// extracted by mini-css-extract-plugin
module.exports = {"s2saw5r":"s2saw5r","disabled":"disabled","selected":"selected"};